<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
            <TabView >
            <TabPanel header="รายละเอียดข้อมูล">
                <report-disaster-detail></report-disaster-detail>
            </TabPanel>
            <TabPanel header="สรุปจำนวนเหตุการณ์">
                <report-disaster-amount></report-disaster-amount>
            </TabPanel>
            <TabPanel header="กราฟสรุปตามประเภทสาธารณภัย (รายเดือน)">
                <report-disaster-graph-month></report-disaster-graph-month>
            </TabPanel>
            <TabPanel header="กราฟสรุปตามประเภทสาธารณภัย (รายปี)">
                <report-disaster-graph-year></report-disaster-graph-year>
            </TabPanel>
            <TabPanel header="กราฟสรุปตามพื้นที่เกิดเหตุ (รายเดือน)">
                <report-disaster-location-graph-month></report-disaster-location-graph-month>
            </TabPanel>
            <TabPanel header="กราฟสรุปตามพื้นที่เกิดเหตุ (รายปี)">
                <report-disaster-location-graph-year></report-disaster-location-graph-year>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportDisasterDetail from './ReportDisasterDetail';
import reportDisasterAmount from './ReportDisasterAmount';
import reportDisasterGraphMonth from './ReportDisasterGraphMonth';
import reportDisasterGraphYear from './ReportDisasterGraphYear';
import reportDisasterLocationGraphMonth from './ReportDisasterLocationGraphMonth';
import reportDisasterLocationGraphYear from './ReportDisasterLocationGraphYear';

export default {
    components: {
        reportDisasterDetail,
        reportDisasterAmount,
        reportDisasterGraphMonth,
        reportDisasterGraphYear,
        reportDisasterLocationGraphMonth,
        reportDisasterLocationGraphYear
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>